module.exports = __webpack_public_path__ + "img/rose.c9506cbf.svg";